import { useState, useEffect } from "react";
import api from "../constant/api";
import { toast } from "react-toastify";

export default function MenuManagement() {
  const [menuGroups, setMenuGroups] = useState([]);
  const [formData, setFormData] = useState({
    group_name: "",
    title: "",
    path: "",
    icon_name: "Package",
    sort_order: 0
  });

  const loadMenus = async () => {
    try {
      const res = await api.get("/menus/getMenus");
      if (res.data?.success) setMenuGroups(res.data.data);
    } catch (err) {
      toast.error("Failed to fetch layouts data tracking");
    }
  };

  useEffect(() => { loadMenus(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/menus/saveMenu", formData);
      toast.success("Menu added successfully!");
      setFormData({ group_name: "", title: "", path: "", icon_name: "Package", sort_order: 0 });
      loadMenus();
      window.dispatchEvent(new Event("settingsSaved")); // Alert topbar/sidebar instantly
    } catch (err) {
      toast.error("Error creating core target route entry");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this navigation link entry?")) return;
    try {
      await api.delete(`/menus/deleteMenu/${id}`);
      toast.success("Menu item removed");
      loadMenus();
      window.dispatchEvent(new Event("settingsSaved"));
    } catch (err) {
      toast.error("Deletion task rejected");
    }
  };

  return (
    <div className="p-6 max-w-6xl mx-auto space-y-6">
      <div className="bg-white p-6 rounded-2xl border shadow-sm">
        <h1 className="text-xl font-bold text-gray-900">System Menu Module Configuration</h1>
        <p className="text-xs text-gray-500 mt-1">Configure structural items visible dynamically on layout sidebars.</p>
        
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-5 gap-3 mt-4 items-end">
          <div>
            <label className="text-xs font-semibold text-gray-600">Group Categorization Name</label>
            <input type="text" required value={formData.group_name} placeholder="e.g., Sales, Operations" onChange={e => setFormData({...formData, group_name: e.target.value})} className="w-full mt-1 border rounded-xl p-2 text-sm outline-none focus:border-indigo-500" />
          </div>
          <div>
            <label className="text-xs font-semibold text-gray-600">Menu Display Title</label>
            <input type="text" required value={formData.title} placeholder="e.g., Active Orders" onChange={e => setFormData({...formData, title: e.target.value})} className="w-full mt-1 border rounded-xl p-2 text-sm outline-none focus:border-indigo-500" />
          </div>
          <div>
            <label className="text-xs font-semibold text-gray-600">Browser Path Navigation Link</label>
            <input type="text" required value={formData.path} placeholder="/Order" onChange={e => setFormData({...formData, path: e.target.value})} className="w-full mt-1 border rounded-xl p-2 text-sm outline-none focus:border-indigo-500" />
          </div>
          <div>
            <label className="text-xs font-semibold text-gray-600">Lucide Vector Icon Name</label>
            <select value={formData.icon_name} onChange={e => setFormData({...formData, icon_name: e.target.value})} className="w-full mt-1 border rounded-xl p-2 text-sm outline-none bg-white">
              <option value="LayoutDashboard">Dashboard</option>
              <option value="Package">Package</option>
              <option value="ShoppingCart">Order</option>
              <option value="Users">Users</option>
              <option value="Settings">Settings</option>
            </select>
          </div>
          <button type="submit" className="bg-indigo-600 text-white rounded-xl py-2 px-4 hover:bg-indigo-700 font-medium text-sm shadow-sm transition">
            ➕ Add Menu Item
          </button>
        </form>
      </div>

      {/* RENDER DYNAMIC LIST VIEW PREVIEW */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {menuGroups.map((group, idx) => (
          <div key={idx} className="bg-white p-5 rounded-2xl border shadow-xs">
            <h3 className="text-xs font-bold text-indigo-600 uppercase tracking-widest border-b pb-2 mb-3">{group.groupName}</h3>
            <div className="space-y-2">
              {group.items.map((item) => (
                <div key={item.id} className="flex justify-between items-center bg-gray-50 p-2.5 rounded-xl border border-gray-100">
                  <div className="text-xs font-semibold text-gray-700">
                    {item.title} <span className="text-[10px] text-gray-400 font-normal ml-2">({item.to})</span>
                  </div>
                  <button onClick={() => handleDelete(item.id)} className="text-xs text-red-500 hover:text-red-700 p-1">🗑️</button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}